import React from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { MoonIcon, SunIcon } from '../../../ui/Icons';

export interface DarkModeToggleProps {
  className?: string;
}

/**
 * DarkModeToggle component for switching between light and dark themes.
 * Shows moon icon in light mode, sun icon in dark mode.
 */
export const DarkModeToggle: React.FC<DarkModeToggleProps> = ({
  className = '',
}) => {
  const { resolvedTheme, toggleTheme } = useTheme();

  const isDark = resolvedTheme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className={`
        p-2 rounded-lg transition-colors
        text-secondary-500 dark:text-secondary-400
        hover:bg-secondary-100 dark:hover:bg-secondary-800
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        dark:focus:ring-offset-secondary-900
        ${className}
      `
        .trim()
        .replace(/\s+/g, ' ')}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <SunIcon size={20} /> : <MoonIcon size={20} />}
    </button>
  );
};

export default DarkModeToggle;
